import React from "react";
import {
  FaUserShield,
  FaInfoCircle,
  FaMobileAlt,
  FaEnvelope,
} from "react-icons/fa";
import "./DataDelete.css";

const DataDelete = () => {
  return (
    <div className="data-delete-container">
      <div className="data-delete-content">
        <div>
          <span className="badge">Veri Silme</span>
        </div>

        <div className="header-section">
          <h1 className="title">Veri Silme Talimatları</h1>

          <p className="text">
            Kullanıcı verilerini korumak ve istedikleri zaman erişim veya silme
            hakkı sunmak temel ilkemizdir.
          </p>
          <p className="text">
            Hesap ve veri silme işlemlerinizi kolayca gerçekleştirebilirsiniz.
          </p>
          <div className="last-updated">
            <FaInfoCircle />
            <span>Son güncelleme: 03 Mart, 2025</span>
          </div>
        </div>

        <div className="info-box">
          <p className="text" style={{ marginBottom: 0 }}>
            Uygulamamız, kullanıcıların hesapları ve kişisel verileri üzerinde
            tam kontrol sağlamalarına olanak tanır. Kullanıcılar, istedikleri
            zaman kişisel verilerini silebilir veya hesaplarını tamamen
            kapatabilir. Verilerinizi silmek için aşağıdaki adımları takip
            edebilirsiniz:
          </p>
        </div>

        <div className="section">
          <h2 className="subtitle">
            <FaMobileAlt />
            1. Uygulama Üzerinden Veri Silme:
          </h2>
          <ul className="steps-list">
            <li className="step-item">
              <div className="step-number">1</div>
              <span>Uygulamada "Profil" bölümüne gidin.</span>
            </li>
            <li className="step-item">
              <div className="step-number">2</div>
              <span>"Hesap Ayarları" sekmesine tıklayın.</span>
            </li>
            <li className="step-item">
              <div className="step-number">3</div>
              <span>"Hesabımı Sil" seçeneğine dokunun.</span>
            </li>
            <li className="step-item">
              <div className="step-number">4</div>
              <span>
                Hesabınızı ve ilgili tüm verilerinizi silmek için onay verin.
              </span>
            </li>
          </ul>
        </div>

        <div className="section">
          <h2 className="subtitle">
            <FaEnvelope />
            2. Destek ile İletişime Geçme:
          </h2>
          <p className="text">
            Eğer uygulama içinde veri silme seçeneğini bulamıyorsanız veya sorun
            yaşıyorsanız, bizimle iletişime geçebilirsiniz.
          </p>
          <p className="text">
            Talebinizi aldıktan sonra verilerinizi en kısa sürede sileceğiz ve
            size bir onay e-postası göndereceğiz.
          </p>
          <div className="email-box">
            <div className="email-link">
              <FaEnvelope />
              E-posta:
              <a href="mailto:info@personelika.com">info@personelika.com</a>
            </div>
          </div>
        </div>

        <div className="contact-section">
          <h2 className="subtitle">
            <FaUserShield />
            İletişim
          </h2>
          <p className="text">
            Veri silme talimatları ile ilgili herhangi bir sorunuz varsa bizimle{" "}
            <a href="mailto:info@personelika.com" className="contact-link">
              iletişime geçebilirsiniz
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default DataDelete;
